import * as React from "react";
const SvgReceiptActive = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g fill="#fff" clipPath="url(#receiptActive_svg__a)">
      <path d="M6.17 2C3.255 2 2.283 3.74 2.283 5.887v14.575a.969.969 0 0 0 1.555.778L5.5 19.996a.98.98 0 0 1 1.282.097l1.613 1.623a.98.98 0 0 0 1.38 0l1.633-1.633a.96.96 0 0 1 1.263-.087l1.661 1.244c.642.476 1.555.02 1.555-.778V3.943A1.95 1.95 0 0 1 17.83 2zm-.03 11.67a.975.975 0 0 1-.97-.972c0-.534.436-.971.97-.971.535 0 .973.437.973.971a.975.975 0 0 1-.972.972m0-3.887a.975.975 0 0 1-.97-.971c0-.535.436-.972.97-.972.535 0 .973.437.973.972a.975.975 0 0 1-.972.971M12 13.427H9.085a.734.734 0 0 1-.729-.729c0-.398.33-.728.73-.728H12c.399 0 .729.33.729.728 0 .399-.33.73-.729.73m0-3.887H9.085a.734.734 0 0 1-.729-.728c0-.399.33-.73.73-.73H12c.399 0 .729.331.729.73s-.33.728-.729.728" />
      <path d="M17.84 3.458c.641 0 1.254.262 1.7.7a2.46 2.46 0 0 1 .72 1.729v2.351c0 .72-.321 1.05-1.05 1.05h-1.866V3.953c0-.272.224-.495.496-.495m0-1.458a1.953 1.953 0 0 0-1.953 1.953v6.792h3.323c1.535 0 2.507-.971 2.507-2.507V5.887c0-1.07-.437-2.04-1.137-2.75A3.93 3.93 0 0 0 17.84 2" />
    </g>
    <defs>
      <clipPath id="receiptActive_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgReceiptActive;
